import { getData } from 'conversations-async-data/async-data/operators/getters';
import { createSelector } from 'reselect';
import { getConnectedAccountsAsyncData } from './getConnectedAccountsAsyncData';
export const getAllConnectedAccounts = createSelector(
// @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
[getConnectedAccountsAsyncData], getData);